import { useState } from "react";
import { Switch } from "@headlessui/react";
import { Radio, RadioGroup } from "@headlessui/react";
import PropTypes from "prop-types";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const frequencies = [
    { value: "monthly", label: "Monthly" },
    { value: "annually", label: "Annually" },
];

export default function FrequencyToggle(props) {

    return (
        <RadioGroup
            value={props.isMonthly ? "monthly" : "annually"}
            onChange={props.onChange}
            className="inline-flex items-center cursor-pointer justify-center rounded-full bg-gray-100 ring-1 ring-inset ring-gray-200 p-0.5 sm:space-x-4 sm:p-1 text-center font-semibold text-xs leading-5"
        >
            {frequencies.map((option) => (
                <RadioGroup.Option
                    key={option.value}
                    value={option.value}
                    className={({ checked }) =>
                        classNames(
                            checked
                                ? "bg-green-700 text-white shadow-sm"
                                : "text-gray-600 hover:text-gray-800",
                            // mobile default styles (smaller)
                            "rounded-full px-3.5 py-1 text-[11px] sm:px-4 sm:py-1.5 sm:text-xs transition-colors duration-150"
                        )
                    }
                >
                    {option.label}
                </RadioGroup.Option>
            ))}
        </RadioGroup>


    );
}


FrequencyToggle.propTypes = {
    isMonthly: PropTypes.bool,
    onChange: PropTypes.func,
}
